export class DateTimePicker {
    inputDatetimeFormat?:string;
    showLabel?:boolean;
    openWhenFocus?:boolean;
    goNextWhenSelect?:boolean;
    validatorMessage?: boolean;
    tooltipMessage?: boolean;
    submitted?: boolean;
}